import PropTypes from 'prop-types'
import { gql } from '@apollo/client'
import groupFragment, { groupFragmentPropTypes } from '~/graphql/fragments/group'

const groupCollection = gql`
  fragment groupCollection on GroupCollection {
    id
    type
    status
    title
    subtitle
    numberOfItemsOnFeedOverview: numbersOfItemsOnFeedOverview
    group {
      ...group
    }
  }

  ${groupFragment}
`

export const groupCollectionPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'THUMBNAIL_EVENT_COLLECTION',
    'THUMBNAIL_WITH_URL',
    'THUMBNAIL_BLOG',
    'GROUP_COLLECTION',
    'RECURRING_EVENT_COLLECTION',
    'RECOMMENDED_EVENT_COLLECTION',
  ]).isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'PREVIEW']).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  numberOfItemsOnFeedOverview: PropTypes.number.isRequired,
  group: groupFragmentPropTypes.isRequired,
})

export default groupCollection
